import React from 'react';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';
import { WizardWrapper } from './logic/WizardWrapper';
import { ChangePhoneSteps } from './ChangePhoneSteps';
import { errorCodesEnum } from './logic/useStepHook';

export interface ChangePhoneProps {
  onClose: () => void;
}

export interface ApiError {
  code: number;
  localizedMessage?: string;
}
export interface ErrorData {
  errorMessage?: string;
  errorCode?: number;
  errorKey: errorCodesEnum;
  prevStep?: number;
  inlineError?: boolean;
  localizedMessage?: string;
}
export interface IPayload {
  error?: ErrorData;
  phone?: string;
  lastFourSSN?: string;
  lastFourCard?: string;
  apiResponseData?: string;
  mailAnswer?: string;
  step?: number;
}
export interface ChangePhoneData {
  type: string;
  payload: IPayload;
  step?: number;
  phone?: string;
  lastFourSSN?: string;
  lastFourCard?: string;
  apiResponseData?: any;
  mailAnswer?: string;
  customerId?: string;
  error?: ErrorData;
}

export const ChangePhone = ({ onClose }: ChangePhoneProps) => (
  <div>
    <UserMessage id='change-phone-modal' onClick={onClose} shouldPersist shouldBlur>
      <WizardWrapper>
        <ChangePhoneSteps onClose={onClose} />
      </WizardWrapper>
    </UserMessage>
  </div>
);
